import React, { Fragment } from 'react'
import {
    List, Datagrid, Filter, ShowButton, UrlField, TextInput, DateInput, Button, TextField, EditButton, useListContext, FunctionField, DeleteButton, useRecordContext, Link
} from 'react-admin'
import { InfluencerStatusSelectInput, ViewSelectInput, AdminUserSelectInput } from '../../UI/Input/SelectInput'

import { DateRangeInput } from '../../UI/Input/input';
import useCheckPermissions from '../AdminPermissions/useCheckPermissions'

const ListFilter = (props) => {
    const {

        setFilters,
        hideFilter
    } = useListContext();
    return (

        <Filter {...props}>
            <TextInput label="Search" source="q" alwaysOn />
            <ViewSelectInput label="View" source="view" always alwaysOn />
            <InfluencerStatusSelectInput label="Status" source="status" alwaysOn />
            <DateRangeInput alwaysOn onClear={() => { hideFilter('daterange') }} onChange={(strdate) => {
                setFilters({ daterange: strdate })
            }} />
            <AdminUserSelectInput label="Admin User" source="adminuser" alwaysOn />
        </Filter>
    )
};

const ProfileidFiled = (props) => {
    const record = useRecordContext();
    return (
        <TextField {...props} component={Link} to={`/user?filter={"q":"${record.profile_id}"}`} onClick={(event) => event.stopPropagation()} />
    )
}


const MediaBoosterList = ({ ...props }) => {

    return (
        <List {...props} title="Media Booster" filters={<ListFilter />} filter={{ uid: -1 }} sort={{ field: 'title', order: 'ASC' }}>

            <Datagrid >
                <ProfileidFiled source="profile_id" label="Profile Id" />
                <TextField source='name' label="name" />
                <FunctionField source="watched_video_url" label="Link" render={record => {
                    return (<Button target="_blank" style={{ color: 'green', border: '1px solid' }} href={record.watched_video_url} label="Link" size="small"></Button>)

                }} />
                <TextField source="task_amount" label="Task Amount" />
                <TextField source='created_at' label="Created At" />

                <TextField source="decline_reason" label="Decline Reason" />
           <TextField source="deduction_amount" label="Deduction Amount" />
                <FunctionField source="status" label="Status" render={record => {
                    if (record['status'] === 'Reject') {
                        return (<span style={{ color: 'red' }}>Reject</span>)
                    } else if (record['status'] === 'Pending') {
                        return (<span style={{ color: 'orange' }}>Pending</span>)
                    } else {
                        return (<span style={{ color: 'green' }}>Approved</span>)
                    }
                }} />

                <TextField source="approvedby.name" label="Approved By" />
                <TextField source="assignedby.name" label="Assigned By" />
                <TextField source="assignee.name" label="Assignee" />
                <TextField source="rejactedby.name" label="Rejacted By" />
                <TextField source="assigned_at" label="Assigned Date" />
                <TextField source="approved_at" label="Approved Date" />
                <TextField source="rejected_at" label="Rejected Date" />

                {useCheckPermissions('MediaBooster_Edit') ? <FunctionField source="status" label="Edit Action" render={record => {
                    if (record['status'] === 'Pending') {
                        return (<EditButton />)
                    }

                }} /> : null}
            </Datagrid>

        </List>
    )
}


export default MediaBoosterList